export const CONFIG = 'CONFIG'

export const AUTH_USER = 'AUTH_USER'
export const AUTH_TOKEN = 'AUTH_TOKEN'

export const LOADER_SHOW = 'LOADER_SHOW'
export const LOADER_MESSAGE = 'LOADER_MESSAGE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const NOTIFICATION = 'NOTIFICATION'

export const AXIOS_EXCLUDE_ROUTES_ERROR = 'AXIOS_EXCLUDE_ROUTES_ERROR'



// WEBPACK FOOTER //
// ./src/vuex/types.js